import {
  GENDER_OPTION_ALL,
  GENDER_OPTION_FEMALES,
  GENDER_OPTION_MALES
} from '../ReusableFormFields/GenderFields/fields'
import { OPTION_YES } from '../../constants/forms'

export const ACTIVE = 'active'
export const PAUSED = 'paused'
export const STATUS = 'status'

export const genderOptions = [
  { value: GENDER_OPTION_MALES, label: 'Only males' },
  { value: GENDER_OPTION_FEMALES, label: 'Only females' },
  { value: GENDER_OPTION_ALL, label: 'All' }
]

export const AGE_RANGE_18_24 = 'AGE_RANGE_18_24'
export const AGE_RANGE_25_34 = 'AGE_RANGE_25_34'
export const AGE_RANGE_35_44 = 'AGE_RANGE_35_44'
export const AGE_RANGE_45_54 = 'AGE_RANGE_45_54'
export const AGE_RANGE_55_64 = 'AGE_RANGE_55_64'
export const AGE_RANGE_65_PLUS = 'AGE_RANGE_65_PLUS'

export const dv360CustomAgeRangesInitialValues = {
  [AGE_RANGE_18_24]: false,
  [AGE_RANGE_25_34]: false,
  [AGE_RANGE_35_44]: false,
  [AGE_RANGE_45_54]: false,
  [AGE_RANGE_55_64]: false,
  [AGE_RANGE_65_PLUS]: false
}

// frequency
export const FREQUENCY_OPTION = 'frequency_option'
export const FREQUENCY_TIME_UNIT = 'time_unit'
export const FREQUENCY_IMPRESSIONS = 'max_impressions'

export const timeUnitsValues = {
  TIME_UNIT_LIFETIME: 'TIME_UNIT_LIFETIME',
  TIME_UNIT_MONTHS: 'TIME_UNIT_MONTHS',
  TIME_UNIT_WEEKS: 'TIME_UNIT_WEEKS'
}

export const timeUnitsList = [
  {
    value: timeUnitsValues.TIME_UNIT_LIFETIME,
    label: 'lifetime'
  },
  {
    value: timeUnitsValues.TIME_UNIT_MONTHS,
    label: 'per month'
  },
  {
    value: timeUnitsValues.TIME_UNIT_WEEKS,
    label: 'per week'
  }
]

export const frequencyFields = {
  [FREQUENCY_OPTION]: OPTION_YES,
  [FREQUENCY_TIME_UNIT]: timeUnitsValues.TIME_UNIT_WEEKS
}
